<template>
    <confirmation-component v-if="modalopen" :modal-open="modalopen" :title="title" :html="message" @close="cancel">
        <template #body>
            <div v-html="message" class="text-justify"/>
        </template>
        <template #buttons>
            <div class="iris-confirm-buttons">
                <v-btn medium elevation="4" class="action-btn" @click="cancel">
                    {{ cancelLabel != undefined ? cancelLabel : $t("common.btn_cancel") }}
                </v-btn>
                <v-btn color="success" medium elevation="4" class="action-btn" @click="confirm">
                    {{ confirmLabel != undefined ? confirmLabel : $t("common.lblSave")}}
                </v-btn>
            </div>
        </template>
    </confirmation-component>
</template>
<script>
    export default {
        name: 'irisConfirm',
        data: function () {
            return {
                confirmLabel: undefined,
                cancelLabel: undefined,
                message: undefined,
                callback: undefined,
                modalopen: false,
                title: ""
            }
        },
        methods: {
            async Show(opts = {}, callback) {
                this.modalopen = true
                this.confirmLabel = opts.confirmLabel
                this.cancelLabel = opts.cancelLabel
                this.message = opts.message
                this.title = opts.title

                this.callback = callback
            },

            async confirm() {
                let loader = this.$loading.show({ container: "", isFullPage: true });
                try {
                    await this.callback(true)
                }
                catch (err) {
                    console.log(err)
                }
                this.modalopen = false
                loader.hide()
            },

            async cancel() {
                this.modalopen = false
                await this.callback(false)
            },
        }
    }
</script>
<style scoped>

    .iris-confirm-buttons {
        display: flex;
        justify-content: end;
    }

    .action-btn {
        margin: 0 2px;
    }
</style>